<template>
  <div class="max-w-xl mx-auto mt-10">
    <div class="bg-white shadow sm:rounded-lg" v-if="shouldShowExtensionLink">
      <div class="px-4 py-5 sm:p-6">
        <div class="sm:flex sm:items-start sm:justify-between">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Download Chrome Extension
            </h3>
            <!-- <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Recusandae voluptatibus corrupti atque repudiandae nam.
              </p>
            </div> -->
          </div>

          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                @click="openDownload"
              >
                Add to chrome
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg" v-if="!shouldShowExtensionLink">
      <div class="px-4 py-5 sm:p-6">
        <div class="sm:flex sm:items-start sm:justify-between">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Get invited
            </h3>
            <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
              <p>
                We are releasing this feature in batches. Kindly click the
                button to be invited.
              </p>
            </div>
          </div>

          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                v-if="store.hasJoinedWaitlist"
              >
                We will get back to you soon :)
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white overflow-hidden shadow rounded-lg mt-10">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
        <h1>How It works</h1>
      </div>
      <div class="px-4 py-5 sm:p-6">
        <div class="mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500">
          With automation you can send messages using your WhatsApp number
          automatically! The extension will alert you every time there are
          abandoned carts waiting and with a click we will automatically message
          all of them. You don't have to lift a finger :)
        </div>
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/D1Orz8m_nGs"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg mt-10">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Not using chrome?
        </h3>
        <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
          <p>
            Let us know which browser you are using.
          </p>
          <p v-if="isSaved" class="text-green-400">
            Your request noted :)
          </p>
        </div>

        <div class="mt-5 sm:flex sm:items-center" v-if="!isSaved">
          <div class="max-w-xs w-full">
            <label for="email" class="sr-only">Email</label>
            <div class="relative rounded-md shadow-sm">
              <input
                id="text"
                v-model="browserPreference"
                class="form-input block w-full sm:text-sm sm:leading-5"
                placeholder="Mozilla firefox, Opera.."
              />
            </div>
          </div>
          <span
            class="mt-3 inline-flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto"
          >
            <button
              type="button"
              class="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 sm:w-auto sm:text-sm sm:leading-5"
              @click="saveBrowserPreference"
            >
              Save
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      browserPreference: "",
      isSaving: false,
      isSaved: false
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    },
    shouldShowExtensionLink() {
      let result = true;
      const store = this.$store.getters.getStore;
      if (store && store.isInTrial && store.hasGotInvite === false) {
        result = false;
      }
      return result;
    }
  },
  methods: {
    openDownload() {
      window.open(
        "https://chrome.google.com/webstore/detail/whatsapp-abandoned-cart-r/oafngpdgefiojadcffacffdkpaejigfm",
        "_blank"
      );
    },
    saveBrowserPreference() {
      this.isSaving = true;
      this.$store
        .dispatch("updateConfig", {
          requestParams: {
            browserPreference: this.browserPreference
          }
        })
        .then(() => {
          this.isSaving = false;
          this.isSaved = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
